import { breakpoints } from './breakpoints'
import {
  BP_LARGE, BP_MEDIUM, BP_SMALL, BP_XLARGE, BP_XXLARGE, BP_XXXLARGE,
} from '../shared/stylesheet/Breakpoints'

window.APP.mq = {
  small: window.matchMedia(`screen and ${breakpoints[BP_SMALL].toMediaCondition()}`),
  medium: window.matchMedia(`screen and ${breakpoints[BP_MEDIUM].toMediaCondition()}`),
  large: window.matchMedia(`screen and ${breakpoints[BP_LARGE].toMediaCondition()}`),
  xlarge: window.matchMedia(`screen and ${breakpoints[BP_XLARGE].toMediaCondition()}`),
  xxlarge: window.matchMedia(`screen and ${breakpoints[BP_XXLARGE].toMediaCondition()}`),
  xxxlarge: window.matchMedia(`screen and ${breakpoints[BP_XXXLARGE].toMediaCondition()}`),
}
